



































import { Component, Vue, Watch, Prop } from 'vue-property-decorator'
import { UnitBaseData } from '@/api/heritageUnit/unitBase'
import UnitFileGallery from './fileGallery.vue'
// import UnitFileDetail from './fileDetail.vue'

@Component({
  components: {
    UnitFileGallery
    // , UnitFileDetail 
  }
})
export default class UnitFilesView extends Vue {
  public name = 'UnitFilesView'
  public collapseNames: string[] = []
  public form: any = {
    Pictures: [],
    Drawings: []
  }
  public showDraws: boolean = true
  public showPics: boolean = true

  //从父级页面调用该参数，把表单内容传过来
  public setForm(f: any) {
    this.showDraws = f.Drawings && f.Drawings.length > 0
    if (this.showDraws) {
      this.collapseNames.push('draws')
    }
    this.showPics = f.Pictures && f.Pictures.length > 0
    if (this.showPics) {
      this.collapseNames.push('pics')
    }
    this.form = f
  }
}
